export { Body, body, type BodyVariants } from './Body';
export { Display, display, type DisplayVariants } from './Display';
export { Heading, heading, type HeadingVariants } from './Heading';
export { Label, label, type LabelVariants } from './Label';
export { Overline, overline, type OverlineVariants } from './Overline';
export { base } from './base';
